<template>
  <div class="overall_situation">
    <!-- 导航栏 - S -->
    <nav class="ct-header navbar navbar-default navbar-fixed-top" v-if="IsShowSmallMenu==false">
      <!--glyphicon glyphicon-menu-hamburger -->
      <div class="container-fluid">
        <div class="row fluid_row">
            <div class="col-md-2 col-md-push-1 col-sm-2 col-sm-pull-0 col-xs-3" style="text-align:right;"> 
              <router-link to="/home">
                <img src="../assets/images/logo_header.png"  class="logo-header" />
              </router-link>
            </div>
            <div class="col-md-7  col-sm-10  col-xs-11" >
              <div class="nav-right">
                <div class="nav-right-item" :class="active=='home'?'active':''"  @click="liJump('home','')">{{$t('NavabarText.navbar_home')}}</div>
                <div class="nav-right-item" :class="active=='product'?'active':''"  @click="liJump('product','')">{{$t('NavabarText.navbar_product')}}</div>
                <div class="nav-right-item" :class="active=='cases'?'active':''"  @click="liJump('cases','')">{{$t('NavabarText.navbar_case')}}</div>
                <div class="nav-right-item" :class="active=='services'?'active':''"  @click="liJump('services','')">{{$t('NavabarText.navbar_item')}}</div>
                <div class="nav-right-item" :class="active=='about'?'active':''" @mouseenter="mouseenter('about')" @mouseleave="leaveSecond()">
                  <span  @click="liJump('about','')">{{$t('NavabarText.navbar_about')}}</span>
                  <!-- <div v-if="dropdownIndex=='about'" class="dropdown level_prompt">
                    <div class="arrow"> <span></span></div>
                    <ul :class="$store.state.lang!='en-US'?'':'second_ul_special'" >
                        <li @click="liJump('concat', '')">
                          <span>{{$t('NavabarText.navbar_contact')}}</span>
                        </li>
                    </ul>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="col-md-3 lang_header">
              
                    <div class="lang-transfer" @click="langChangClick('zh-CN')">
                      <img src="../assets/images/cn.png" class="logo-headers"/>
                      <span class="lang">简</span>
                    </div>
                    <div class="lang-transfer" @click="langChangClick('zh-TCC')">
                      <img src="../assets/images/hk.png" class="logo-headers"/>
                      <span class="lang">繁</span>
                    </div>
                    <div class="lang-transfer" @click="langChangClick('en-US')">
                      <img src="../assets/images/en.png" class="logo-headers"/>
                      <span class="lang">Eng</span>
                    </div>
            </div>
        </div>
      </div>
    
      <!-- <el-row class="row row_header ">
          <el-col :span="2" ></el-col>
          <el-col :span="3" style="text-align:right;"> 
              <router-link to="/home">
                <img src="../assets/images/logo_header.png"  class="logo-header" />
              </router-link>
          </el-col>
          <el-col :span="14"  class="row_header_nav">
              <div class="nav-right">
                <div class="nav-right-item" :class="active=='home'?'active':''"  @click="liJump('home','')">{{$t('NavabarText.navbar_home')}}</div>
                <div class="nav-right-item" :class="active=='productCenter'?'active':''"  @click="liJump('','')">{{$t('NavabarText.navbar_product')}}</div>
                <div class="nav-right-item" :class="active=='caseCenter'?'active':''"  @click="liJump('','')">{{$t('NavabarText.navbar_case')}}</div>
                <div class="nav-right-item" :class="active=='serviceSupport'?'active':''"  @click="liJump('','')">{{$t('NavabarText.navbar_item')}}</div>
                <div class="nav-right-item" :class="active=='about'?'active':''" @mouseenter="mouseenter('about')" @mouseleave="leaveSecond()">
                  <span  @click="liJump('about','')">{{$t('NavabarText.navbar_about')}}</span>
                  <div v-if="dropdownIndex=='about'" class="dropdown">
                  
                    <ul :class="$store.state.lang!='en-US'?'':'second_ul_special'" >
                        <li @click="liJump('concat', '')">
                          <span>{{$t('NavabarText.navbar_contact')}}</span>
                        </li>
                    </ul>
                  </div>
                </div>
              </div>
          </el-col>
          <el-col :span="3" class="lang_header">
                    <div class="lang-transfer" @click="langChangClick('zh-TCC')">
                      <img src="../assets/images/hk.png" class="logo-headers"/>
                      <span class="lang">繁</span>
                    </div>
                    <div class="lang-transfer" @click="langChangClick('zh-CN')">
                      <img src="../assets/images/cn.png" class="logo-headers"/>
                      <span class="lang">简</span>
                    </div>
                    <div class="lang-transfer" @click="langChangClick('en-US')">
                      <img src="../assets/images/en.png" class="logo-headers"/>
                      <span class="lang">Eng</span>
                    </div>
          </el-col>
          
          <el-col :span="2" ></el-col>
      </el-row>   -->
    </nav>

    <nav class="ct-header navbar navbar-default navbar-fixed-top" v-if="IsShowSmallMenu==true">
      <!--glyphicon glyphicon-menu-hamburger -->
      <div class="container-fluid">
        <div class="row fluid_row">
          <div class="col-md-1 icon_menu"
               :class="IsShowMenu?'icon_menu_special':''">
            <i class="icon iconfont icon-caidan iconcaidan" @click="IsShowMenu=true"></i>
            <!-- <i class="icon iconfont iconcaidan "></i> -->
          </div>
          <div class="col-xs-7 col-md-9 header-logo"
               v-if="!IsShowMenu">
            <router-link to="/home">
              <img src="../assets/images/logo_header.png"
                   class="logo-header" />
            </router-link>
          </div>
        </div>
      </div>
      <!-- <div class="header-logo">
          <router-link to="/home">
            <img src="../assets/images/logo.png" class="logo-header"/>
          </router-link>
      </div> -->
      <div v-if="IsShowMenu"
           class="ct_dimback">
        <!-- <img src="../../static/images/memu_bg.png"
             style="width:100%; opacity:0.1; height:100vh;filter: alpha(opacity=60);" /> -->
             <span class="icon iconfont icon-caidan"></span>
        <div class="ct-content">
          <div class="href-ul">
            <div class="content_header">
              <div class="col-xs-3 col-md-1 close_icon">
                <i class="glyphicon glyphicon-remove icon_close"
                   @click="IsShowMenu=false"></i>
              </div>
              <div class="col-xs-6 col-md-9 white_logo"  @click="liJump('home')">
                <img src="../assets/images/meny_logo.png" class="logo_header" />
              </div>
            </div>
            <ul class="nav nav-pills">
              <li>
                <a @click="liJump('about')" :class="active=='aboutUs'?'active':''">{{$t('NavabarText.navbar_about')}}</a>
              </li>
              <li>
                <a @click="liJump('product')" :class="active=='product'?'active':''">{{$t('NavabarText.navbar_product')}}</a>
              </li>
              <li>
                <a @click="liJump('cases')" :class="active=='cases'?'active':''">{{$t('NavabarText.navbar_case')}}</a>
              </li>
              <li>
                <a @click="liJump('services')" :class="active=='services'?'active':''">{{$t('NavabarText.navbar_item')}}</a>
              </li>
              <!-- <li>
                <a @click="liJump('concat')" :class="active=='concat'?'active':''">{{$t('NavabarText.navbar_contact')}}</a>
              </li> -->
            </ul>
          </div>
          <div class="lang_flex">            
            <div class="lang-transfer"
                 @click="langChangClick('zh-CN')">
              <img src="../assets/images/cn.png"
                   class="logo-headers" />
              <span class="lang small-logo-headers">简</span>
            </div>
            <div class="lang-transfer"
                 @click="langChangClick('zh-TCC')">
              <img src="../assets/images/hk.png"
                   class="logo-headers" />
              <span class="lang small-logo-headers">繁</span>
            </div>
            <div class="lang-transfer"
                 @click="langChangClick('en-US')">
              <img src="../assets/images/en.png"
                   class="logo-headers" />
              <span class="lang small-logo-headers">Eng</span>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <!-- 导航栏 - E -->
    <!-- <div class="seat_div"></div> -->
    <div class="routerview"
         v-show="!IsShowMenu">
      <router-view></router-view>
    </div>
    <div class="foot-bottom-content-s">
      <div class="foot-bottom-content">
        <div class="foot-bottom-content-item">
          {{$t('footText.version')}}
        </div>
        <div class="foot-bottom-content-item" @click="openClick()">
          粤ICP备2021177006号
        </div>
      </div>
    </div>
  </div>
</template>


<script type="text/javascript">
export default {
  metaInfo () {
    return {
      title: this.pageTitle
    }
  },
  data () {
    return {
      langText: this.$store.state.lang == 'en-US' ? 'English | 繁' : '繁 | English',
      active: 'home',
      dropdownIndex: '',
      dropdownSecondIndex: '',
      IsShowMenu: false,
      activityTwo: '',
      pageTitle: '广州市优科易网络科技有限公司',
      IsShowSmallMenu:false,

    }
  },
  computed: {
    isEn: function () {
      return this.$store.state.lang == 'en-US'
    }
  },
  watch: {
    '$store.state.lang': function (nval, oval) {
      let obj = {
        'en-US': 'Guangzhou youkeyi Network Technology Co., Ltd',
        'zh-TCC': '廣州市優科易網絡科技有限公司',
        'zh-CN': '广州市优科易网络科技有限公司'
      }
      this.pageTitle = obj[nval];
      console.log('jinlaile 进来了',this.pageTitle);
    },
    '$route.name':function(nval,oval){
      this.active=nval;
      console.log(nval,oval,'$route.name')
    },
  },
  onShow(){
    
   
  },
  mounted () {
    //this.langText = this.$store.state.lang == 'en-US' ? 'English | 繁' : '繁 | English';
    console.log('window width:',document.body.clientWidth);

    let _path = this.$route.name
    this.active = _path;
    if(this.isMobileDevice()){
      this.IsShowSmallMenu=true;
    }else{
      this.IsShowSmallMenu=false;
       const that=this;
      window.onresize=()=>{
        return(()=>{
          let clientWidth=document.body.clientWidth;
          if(clientWidth<679){
            that.IsShowSmallMenu=true;
          }else{
            that.IsShowSmallMenu=false;
          }
        })()
      }
    }
   
  },
  methods: {
    langChangClick (lang) {
      this.$store.commit('setlang', lang);
      this.$i18n.locale = lang;
      if (lang == 'en-US') {
        $('#app').addClass('font_family');
        $('#app').removeClass('font_family_cn');
      } else {
        $('#app').addClass('font_family_cn');
        $('#app').removeClass('font_family');
      }
      this.IsShowMenu = false;
    },
    handleTabsClick (name) {
      if (this.active == name) {
        this.active = ''
      } else {
        this.active = name;
      }
      // this.active=name;
      // this.IsShowMenu=false;
      // this.$router.push({
      //   path: name
      // });
    },
    mouseenter (value) {
      this.dropdownIndex = value
    },
    leave () {
      this.$set(this, 'IsShowMenu', false)

    },
    mouseenterSecond (value) {
      this.dropdownSecondIndex = value
    },
    leaveSecond () {
      this.dropdownSecondIndex = ''
      this.dropdownIndex = ''
    },
    liJump (path, hash) {
      this.active = path;
      this.IsShowMenu = false;
    //   let _path = this.$route.name
    //   //if (path == _path) return
    //   console.log(path,this.pageTitle,this.langText)
      this.$router.push({
        path: path,
        hash: hash || ''
      })
    },
    liJumps (path) {
      this.$router.push({
        path: path
      })
    },
    isMobileDevice() {
        let isMobile = false;
        let thisOS = navigator.platform,
          userAgent = navigator.userAgent,
          appVersion = navigator.appVersion;
        let os = ["iPhone", "iPod", "iPad", "android", "Nokia", "SymbianOS", "Symbian", "Windows Phone", "Phone", "Linux armv71", "MAUI", "UNTRUSTED/1.0", "Windows CE", "BlackBerry", "IEMobile"];
        for (let i = 0; i < os.length; i++)
          if (thisOS.match(os[i]) || userAgent.match(os[i] || appVersion.match(os[i])))
            isMobile = true;

        //因为相当部分的手机系统不知道信息,这里是做临时性特殊辨认
        if (navigator.platform.indexOf('iPad') != -1)
          isMobile = true;

        //做这一部分是因为Android手机的内核也是Linux
        //但是navigator.platform显示信息不尽相同情况繁多,因此从浏览器下手，即用navigator.appVersion信息做判断
        if (appVersion.match(/linux/i))
        //X11是UC浏览器的平台 ，如果有其他特殊浏览器也可以附加上条件
          if (appVersion.match(/mobile/i) || appVersion.match(/X11/i))
            isMobile = true;

        return isMobile;
      },
      openClick(){
        window.open('https://beian.miit.gov.cn/#/Integrated/index');
      },
  },
}

</script>

<style lang="scss" scoped>
@import '../assets/font/iconfont.css';
.overall_situation{
  height: 100%;

}
.ct-header {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: #ffffff;
  //z-index: 99999;
  margin-bottom: 0;
}
.container-fluid {
  width: 100%;
  margin: 0 0;
  .fluid_row {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 150px;
    box-shadow: 7px 7px 16px 0px rgba(19,36,51,0.08)  !important;
  }
  .nav-right{
    display:flex;
    justify-content: flex-end;
    align-items: center;
  }
  .nav-right-item{
    position: relative;
    font-size:24px;
    margin-right:45px;
    margin-left:45px;
    cursor:pointer;
    &:nth-child(1){
      margin-left:40px !important;
    }
    &:last-child{
      margin-right:0px;
    }

  }
  .nav-right-item:hover{
    color:#009fe9 !important;
  }
  .nav-right-item:active{
    color:#009fe9;
  }
  .nav-right-item:focus{
    color:#009fe9;
  }
}

.row_header{
  height: 160px;
  width:100%;
  padding:0 0 !important;
  margin:0 0 !important;
  display: flex;
  align-items: center;
}
.row_header_nav{
  // display: flex;
  // align-items: center;
  justify-content:space-between;
   .nav-right{
    display:flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
  }
  .nav-right-item{
    position: relative;
    font-size:24px;
    padding-right:30px;
    padding-left:25px;
    cursor:pointer;
    &:first-child{
      padding-left:0px !important;
    }
    &:last-child{
      margin-right:0px;
    }

  }
  .nav-right-item:hover{
    color:#009fe9;
  }
  .nav-right-item:active{
    color:#009fe9;
  }
  .nav-right-item:focus{
    color:#009fe9;
  }
}

 .lang_header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    // margin-left:30px;
    padding-left:45px;
  }

  .lang-transfer {
    display:flex;
    align-items:center;
    padding:0 5px;
    font-family: AlibabaPuHuiTi-Regular;
    font-size: 16px;
    font-stretch: normal;
    font-weight: 500;
    color: #3a3a3a;
    cursor: pointer;
    .lang{
      color:#3a3a3a;
      font-size:20px;
    }
  }

  .lang-transfer span:hover {
    //  background-color: #009fe9!important;
    color: #00a0e9 !important;
  }

.s_li_content {
  & > li:first-child {
    margin-top: -20px;
  }
}
.icon_menu {
  position: absolute;
  display: flex;
  align-items: center;
  left: 20px;
  color: #009fe9;
  text-align: left;
}
.icon_menu_special {
  color: #fff;
}
.iconcaidan {
  font-size: 34px;
  border: 2px solid #009fe9;
  border-radius: 5px;
  padding: 2px 4px;
}

.logo-weixin {
  height: auto;
  width: 249px;
  height: 249px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.weixin-text {
  font-size: 28px;
  font-family: AlibabaPuHuiTi;
  font-weight: 500;
  color: #000000;
  margin-top: 18px;
}
.header-logo {
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  position: relative;
  padding-left: 0px;
  // width: 476px;
  // height: 83px;
  box-sizing: border-box;
}
.ct_dimback {
  background: #354663;
  position: absolute;
  top: 0;
  z-index: 99999;
  width: 100%;
  filter: alpha(opacity=10);
  height: 100vh;
}
.ct-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  //background: url('/static/images/memu_bg.png') no-repeat;
  // background-size: 100% 100%;
  color: #fff;
  text-align: left;
  z-index: 999999;
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
}
.nav-pills {
  display: flex;
  flex-direction: column;
  color: #fff;
  margin-top: 16px;
}
.search-tip {
  margin-top: 10px;
  width: 100%;
  text-align: center;
  .search-btn {
    display: inline-block;
    width: 268px;
    height: 112px;
    line-height: 112px;
    background-color: #fff;
    border-radius: 60px;
    padding: 0px 40px;
    border: solid 1px #fff;
    text-decoration: none;
    font-family: MicrosoftYaHei;
    cursor: pointer;
    font-size: 30px;
    font-weight: bold;
    letter-spacing: 2px;
    color: #368da4;
    .iconsousuo {
      font-size: 30px;
      font-weight: bold;
    }
  }
}
.search-tip a:hover {
  background-color: #009fe9 !important;
  color: #fff;
}
.href-ul {
  width: 100%;
  height: 100%;
  z-index: 9999999;
  .content_header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    padding: 50px 0 90px 0;
    .close_icon {
      padding-left: 30px;
      font-size: 34px;
    }
  }
  .white_logo {
    height: auto;
    padding-left: 0px;

    .logo_header {
      width: 100%;
      height: auto;
    }
  }
}

.lang_flex {
  display: flex;
  text-align: center;
  margin: 50px 0 120px 0;
  .lang-transfer{
    margin-right:20px;
    &:last-child{
      margin-right: 0px !important;
    }
  }
}
// .lang-transfer {
//   padding: 0 28px;
//   font-size: 30px;
//   font-weight: 600;
//   font-stretch: normal;
//   letter-spacing: 0rem;
//   color: #fff;
//   cursor: pointer;
//   font-family: MicrosoftYaHei;
// }
.navbar-default {
  border-color: #ffffff !important;
}

.three-line {
  color: #009fe9;
  font-size: 2.5rem;
}

.dropdown-menu {
  min-width: 4rem !important;
}
.nav > li {
  margin-bottom: 50px;
}
.nav li a {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 38px;
  font-weight: bold;
  text-transform: none;
  font-stretch: normal;
  letter-spacing: 2px;
}
.dropdrow_a {
  position: relative;
}
.dropdrow_a:hover {
}
.xiala {
  margin-left: 1rem;
  font-size: 16px;
}
.xiangyou {
  font-size: 12px;
  color: #fff;
}
.second-ul {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.dropdown {
  position: absolute;
  padding: 2px 10px;
  background-color: #f5f5f5 !important;
  text-align: center;
  z-index: 9999999;
  border-radius: 10px ;
  // left: 174px;
  min-width: 150px;
  display: flex;
  justify-content: center;
  position: fixed;
  color: #fff;
  margin-left:-10px;
  ul {
    list-style: none;
    padding: 7px 0;
    margin: 0;
    line-height: 27px;
    letter-spacing: 0.07em !important;
    color: #000;
    font-weight: 500;
    font-size: 20px;
  }
  ul:hover{
    color: #009fe9;
  }
  li {
    padding: 3px 0;
    cursor: pointer;
  }
  li {
    .active {
      color: #009fe9;
    }
  }
}
.second-ul {
}
.second-div {
  position: relative;
}
.dropdown-second {
  display: block;
  position: absolute;
  padding: 10px 20px;
  background-color: #009fe9;
  left: 100%;
  margin-left: 20px;
  min-width: 225px;
  top: -18px;
  overflow: visible;
  ul {
    list-style: none;
    padding: 7px 0;
    margin: 0;
    line-height: 27px;
    letter-spacing: 0.07em !important;
    color: #3b3b3b;
    font-weight: 400;
    font-size: 18px;
  }
  li {
    padding: 3px 0;
    cursor: pointer;
  }
  li:hover {
    color: #009fe9;
  }
}
.nav > li > a:focus,
.nav > li > a:hover {
  background: transparent;
}
.nav li {
  a.active {
    color: #009fe9 !important;
  }
}
.nav-pills li a {
  border-radius: 0;
}
.nav-pills > li + li {
  margin-left: 0;
}
.nav-pills ul {
  list-style: none;
  margin: 0;
  text-align: center;
  li {
    font-size: 33px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    padding-bottom: 52px;
    color: #ffffff;
  }
}
.active {
  color: #009fe9 !important;
}
// .nav li a:link{
//    background: #368da7;
//   color:#fff;
// }
.dropdown-menu li a {
  font-size: 1.2rem;
  letter-spacing: 0rem;
  color: #009fe9;
  font-weight: bold !important;
}

.dropdown-menu li a:active {
  color: #009fe9 !important;
}

.logo-header {
  // width: 100%;
  // height: auto;
}

.logo-headers {
  width: 36px;
  height: 24px;
}
.lang {
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 28px;
  letter-spacing: 2px;
  color: #ffffff;
  margin-left: 6px;
}
.small-logo-headers{
  color:#ffffff !important;

}
.lang:hover {
  // color: #fff !important;
}
.seat_div {
  height: 179px;
  width: 100%;
}
.routerview {
  // padding-top: 179px;
  // background: #000000;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height:100%;
  overflow-y: auto;
  left: 0;
  right: 0;
  // top:160px;
  padding-top:150px;
  margin-bottom: 0px;
}
.foot-bottom-content-s{
  width:100%;
  
  background: #131416;
}
.foot-bottom-content {
  width: 70%;
  padding: 40px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  background: #131416;
  position: relative;
  flex-wrap: wrap;
  bottom: 0px;
  margin:auto;

  .foot-bottom-content-item {
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    font-family: AlibabaPuHuiTi;
    font-weight: 400;
    color: #fff;
    cursor: pointer;
    margin-bottom:10px;
    text-align: center;
    //width:33.33%;
    a {
      color: #009fe9;
    }
  }
  .cursor {
    cursor: pointer;
  }
  .cursor:hover {
    color: #9bd9dd;
  }
}
.foot_ul {
  text-align: left;
  margin-left: 27px;
  font-size: 24px;
  margin-bottom: 10px;
  li {
    list-style-type: none;
    margin-bottom: 15px;
    cursor: pointer;
  }
}



.level_prompt{
    // margin-top: 100px; 
    // width:280px; 
    // height:80px; 
    // position:relative;
    margin-top:9px;

}
.arrow{ 
    position:absolute; 
    width:48px; 
    height:48px; 
    bottom:20px; 
    left:10px; 
}
.arrow *{ 
    display:block;     
    border-width:18px 18px; 
    position:absolute; 
    border-style:solid dashed dashed dashed;
    // border-left: 50px solid transparent;
    // border-right: 50px solid transparent;
    // border-bottom: 100px solid red;
    font-size:0; 
    line-height:0; 
}
.arrow span{
    border-color:transparent  #f5f5f5 transparent transparent;
    top:0px; 
    left: 50px;
}
</style>

<style>

/* 超小屏幕（手机，小于 768px） */
/* 没有任何媒体查询相关的代码，因为这在 Bootstrap 中是默认的（还记得 Bootstrap 是移动设备优先的吗？） */

/* 小屏幕（平板，大于等于 768px） */
@media (min-width: @screen-sm-min) { 
    .nav-right-item{
     font-size:14px !important;
   }
}

/* 中等屏幕（桌面显示器，大于等于 992px） */
@media (min-width: @screen-md-min) { 

 }

/* 大屏幕（大桌面显示器，大于等于 1200px） */
@media (min-width: @screen-lg-min) { 

}
@media (max-width: 750px){
  
  .routerview{
  padding-top:120px !important;
  }
  /* .ct-header{
    width:1200px !important;
  } */
  .fluid_row{
    height: 120px !important;
  }
  /* .routerview{
    top:120px !important;
  } */
  .logo-header{
    width:100%;
  }
  .nav-right-item{
     font-size:20px !important;
     margin-left:15px !important;
     margin-right: 15px !important;
  }
  
  .lang_header{
    margin-left:10px !important;
  }
}
@media (min-width: 750px) and (max-width: 860px){
 .fluid_row{
   height: 150px !important;
 }
 
  /* .routerview{
    top:140px !important;
  } */
  .nav-right-item{
     font-size:20px !important;
     margin-left:15px !important;
     margin-right: 15px !important;
  }
  .logo-header{
    width:130%;
  }
}
@media (min-width: 860px) and (max-width:1200px){
  
  .fluid_row{
    height: 150px !important;
  }
  
  .routerview{
    /* top:150px !important; */
  }
  .nav-right-item{
     font-size:22px !important;
     margin-left:22px !important;
     margin-right: 22px !important;
  }
  .lang_header{
    margin-left:10px !important;
  }
}
@media (min-width: 1200px){                  
  
  .fluid_row{
    height: 150px !important;
  }
  
  .routerview{
    /* top:150px !important; */
  }
  .nav-right-item{
     font-size:22px !important;
     margin-left:40px !important;
     margin-right: 40px !important;
  }
  .lang_header{
    margin-left:20px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue